



















































































































































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import {
  PolicyFundDto,
  PolicyBenefitDto,
  PolicyValuesDto,
  PolicyDto,
  PerformanceChartSeriesDto,
  PerformanceChartDataDto
} from "@/api/ClientPortalApiClient";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import { SEE_OTHER } from "http-status-codes";
import { LoadingSpinnerService, RoleStore } from "@/store";
import { Dictionary } from "vuex";
import FundPerformanceChart from "@/views/policies/charts/FundPerformanceChart.vue";
import FundValuePerformanceChart from "@/views/policies/charts/FundValuePerformanceChart.vue";
import FundMixChart from "@/views/policies/charts/FundMixChart.vue";
import PolicyValues from "@/views/policies/components/PolicyValues.vue";
import PolicyTransactions from "@/views/policies/components/PolicyTransactions.vue";
import PolicyFunds from "@/views/policies/components/PolicyFunds.vue";
import BackButton from "@/components/BackButton.vue";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    PolicyValues,
    PolicyTransactions,
    FundPerformanceChart,
    FundValuePerformanceChart,
    FundMixChart,
    PolicyFunds,
    BackButton
  }
})
export default class PolicyDetails_Investment extends Vue {
  private policyDetails: PolicyDto = new PolicyDto();
  private policyId: number | undefined;
  private contactId: number | undefined;

  async created() {
    LoadingSpinnerService.Show("Loading policy details...");
    try {
      this.contactId = parseInt(this.$route.params.contactId);
      this.policyId = parseInt(this.$route.params.policyId);
      await this.getPolicyDetails();
      LoadingSpinnerService.Hide();
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Failed to load policy details. Please try again."
      );
    }
  }

  private async getPolicyDetails() {
    if (!this.policyId || !this.contactId)
      throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    const result = await api.policies_GetByPolicyId(
      this.contactId,
      this.policyId
    );
    this.policyDetails = result || new PolicyDto();
  }

  private displayTransactions(): boolean {
    if (this.policyDetails) {
      if (this.policyDetails.categoryName === "Cash") {
        return true;
      } else console.log("CategoryName: Empty");
    }
    return false;
  }

  get policyEndDateString(): string {
    return new Date(this.policyDetails.maturityDate) <= new Date("01/01/1900")
      ? "Open Ended"
      : FormatDate.format(this.policyDetails.maturityDate);
  }

  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker;
  }

  get FundMixType(): number {
    return this.IsExternalBroker ? 3 : 2;
  }

  private base64ToArrayBuffer(base64: string) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}
